import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        stack: {
            display: 'flex',
            flexDir: 'row',
            alignItems: 'center',
            spacing: 0,
        },
        decButton: {
            width: remCalc(26),
            maxWidth: remCalc(26),
            height: remCalc(26),
            bg: 'background.grey',
            color: 'text.inverse',
            borderLeftRadius: 'small.lg',
        },
        decButtonActive: {
            bg: 'background.brand',
            width: remCalc(26),
            maxWidth: remCalc(26),
            height: remCalc(26),
            color: 'text.inverse',
            borderLeftRadius: 'small.lg',
        },
        input: {
            width: remCalc(30),
            maxWidth: remCalc(30),
            height: remCalc(26),
            textAlign: 'center',
            bg: 'background.default',
            borderRadius: 0,
            textStyle: 'body-small',
            fontWeight: 'normal',
            border: 0,
            borderTop: remCalc(1),
            borderBottom: remCalc(1),
            borderColor: 'border.light',
            borderStyle: 'solid',
            paddingX: 0,
        },
        inputReturn: {
            width: remCalc(30),
            maxWidth: remCalc(30),
            height: remCalc(26),
            textAlign: 'center',
            bg: 'white',
            borderRadius: 0,
            textStyle: 'body-small',
            fontWeight: 'normal',
            border: 0,
            borderColor: 'border.light',
            borderStyle: 'solid',
            paddingX: 0,
        },
        incButton: {
            width: remCalc(26),
            height: remCalc(26),
            bg: 'background.grey',
            color: 'text.inverse',
            borderRightRadius: 'small.lg',
        },
        incButtonActive: {
            width: remCalc(26),
            height: remCalc(26),
            bg: 'background.brand',
            color: 'text.inverse',
            borderRightRadius: 'small.lg',
        },
    },
    variants: {
        OrderDetail: {
            input: {
                backgroundColor: 'background.light',
                color: 'text.disable',
                cursor: 'default',
                border: 'unset',
                maxWidth: 'unset',
                width: remCalc(27),
                height: remCalc(26),
                borderStyle: 'unset',
            },
        },
    },
}
